export default __webpack_public_path__ + "static/media/bernay8.090fbb65.jpg";